// removed by extract-text-webpack-plugin
module.exports = {"Lang":"_2ZXixycwPiTIS8ojLkhbR-","Select":"_2gI2a--KbgrBXnAc7jkdbo","Element":"_12NeNmmFTBvoHC9hADdgk","Current":"_2RmagKhL5MYopubuJOSTLC","Ru":"_3GdXNiNauHVhr9c2AoovTD","En":"_2Mli80iGYlTJtuCcAB2tu2"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/LanguageSelect/styles.module.css
// module id = 554
// module chunks = 0